import { render, staticRenderFns } from "./payFeeOrderConfirm.vue?vue&type=template&id=5b442bf1&scoped=true"
import script from "./payFeeOrderConfirm.vue?vue&type=script&lang=js"
export * from "./payFeeOrderConfirm.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderConfirm.vue?vue&type=style&index=0&id=5b442bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b442bf1",
  null
  
)

export default component.exports